const angular = require('angular');

const { browseTileListComponentDefinition } = require('./browse-tile-list.component');
const { browseLeftPanelComponentDefinition } = require('./browse-left-panel.component');
const { browseZeroResultsComponentDefinition } = require('./browse-zero-results.component');
const { myWeeklyPicksExceptionComponentDefinition } = require('./my-weekly-picks-exception.component');
const { tokenizedWeeklyPicksExceptionComponentDefinition } = require('./tokenized-weekly-picks-exception.component');

angular.module('wowApp.shop')
    .component('wowBrowseTileList', browseTileListComponentDefinition)
    .component('wowBrowseLeftPanel', browseLeftPanelComponentDefinition)
    .component('wowBrowseZeroResults', browseZeroResultsComponentDefinition)
    .component('wowMyWeeklyPicksException', myWeeklyPicksExceptionComponentDefinition)
    .component('wowTokenizedWeeklyPicksException', tokenizedWeeklyPicksExceptionComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/browse/index.js